import type { ReactNode } from 'react';
import './EditorPropertyBar.css';

export interface EditorPropertyBarProps {
  /** Prefix for `data-testid` on the scroll region (`{testIdPrefix}`). */
  testIdPrefix: string;
  /** Passed through by panels; pills receive their own `editable` flag. */
  editable?: boolean;
  /** Inspector narrow width — wraps pills but keeps horizontal scroll. */
  layout?: 'scroll' | 'wrap';
  children: ReactNode;
}

/**
 * Horizontally scrollable row of property pills above the editor title (and
 * reused in the inspector Properties tab).
 */
export function EditorPropertyBar({
  testIdPrefix,
  layout = 'scroll',
  children
}: EditorPropertyBarProps) {
  const cls = [
    'pn-editor-property-bar',
    layout === 'wrap' ? 'pn-editor-property-bar-wrap' : null
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <div className={cls} data-testid={testIdPrefix}>
      <div className="pn-editor-property-bar-track">{children}</div>
    </div>
  );
}
